import { EActionTypes as DT_ATypes } from '../datatable/actionTypes';

export const PREFIX = 'CUSTOMER_';

export default {
  [DT_ATypes.FILTER_CRITERIA_UPADATED]:
    PREFIX + DT_ATypes.FILTER_CRITERIA_UPADATED,
  [DT_ATypes.SORT_CRITERIA_UPADATED]: PREFIX + DT_ATypes.SORT_CRITERIA_UPADATED,
  [DT_ATypes.SEARCH_FETCH]: PREFIX + DT_ATypes.SEARCH_FETCH,
  [DT_ATypes.SEARCH_SUCCESS]: PREFIX + DT_ATypes.SEARCH_SUCCESS,
  [DT_ATypes.SEARCH_ERROR]: PREFIX + DT_ATypes.SEARCH_ERROR,
  [DT_ATypes.TABLE_PAGE_CHANGE]: PREFIX + DT_ATypes.TABLE_PAGE_CHANGE,
  [DT_ATypes.TABLE_PAGESIZE_CHANGE]: PREFIX + DT_ATypes.TABLE_PAGESIZE_CHANGE,
  [DT_ATypes.TABLE_SELECT_ITEM]: PREFIX + DT_ATypes.TABLE_SELECT_ITEM,
  [DT_ATypes.TABLE_TOGGLE_ITEM]: PREFIX + DT_ATypes.TABLE_TOGGLE_ITEM,
  [DT_ATypes.TABLE_TOGGLE_ALL]: PREFIX + DT_ATypes.TABLE_TOGGLE_ALL,
  [DT_ATypes.CLEAR_SELECTION]: PREFIX + DT_ATypes.CLEAR_SELECTION,
  [DT_ATypes.TABLE_COLUMNS_UPDATED]: PREFIX + DT_ATypes.TABLE_COLUMNS_UPDATED,
  TABLE_COLUMNS: `${PREFIX}TABLE_COLUMNS`,
  RESET: `${PREFIX}RESET`,
};
